import React from "react";
import Draggable from 'react-draggable';
import styled from 'styled-components';
import CloseAlternate from '@vds/icons/close-alternate';
import DragHandlerIcon from '@vds/icons/drag-handler';
import Keyboard from './Keyboard';
import './Keyboard.css';


const KeyboardHeader = styled.div`
    background: rgba(131, 131, 131, 0.4);
    border: 0.5px solid #DDD;
    border-radius-top-left: 3px;
    display: block;
    padding: 3px 5px;
    text-align: center;
    color: white;
    width: 67.7rem !important;
    display: flex;  
`;

const Animated = styled.span`
animation-name: slide-up;
animation-duration: 0.85s;
animation-timing-function: ease-in-out;
display:block;
 @keyframes slide-up {
    0% {
        transform: translateY(60%);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}`;

export const FiosReferralKeyboard = ({keyboardContainerClass, onChange, onKeyPress, theme, inputName, closeKeyboard, showKeyboard, keyboard, keyboardEntryLimit, planToolsWithSubmit, planToolsWithSubmitAndTab, keyboardBounds = undefined, stopMouseDownPropagation = false, stopMouseUpPropagation = false }) => {

    const isFiosFlag = sessionStorage?.getItem('fiosReferralFlow') === "true";
    const hostedAttractLoop = sessionStorage.getItem("hostedAttractLoop") === "true";
    const keyboardContainerClassName = `${keyboardContainerClass} floating-keyboard-container`;    

    return <>
        {isFiosFlag && hostedAttractLoop && <div className={keyboardContainerClassName}>
                    {showKeyboard &&
                        <Draggable bounds={keyboardBounds} handle="strong">
                            <Animated>
                                <KeyboardHeader className="keyboard-header" >
                                    <strong className="cursor"><DragHandlerIcon color="white" /></strong><div onClick={closeKeyboard} className="close"><CloseAlternate color="white" /></div>
                                </KeyboardHeader>
                                <Keyboard
                                    ref={keyboard}
                                    onChange={(e) => onChange(e)}
                                    onKeyPress={(button) => onKeyPress(button)}
                                    theme={theme}
                                    inputName={inputName}
                                    key={inputName}
                                    maxLength={keyboardEntryLimit}
                                    planToolsWithSubmit={planToolsWithSubmit}
                                    planToolsWithSubmitAndTab={planToolsWithSubmitAndTab}
                                    stopMouseDownPropagation={stopMouseDownPropagation}
                                    stopMouseUpPropagation={stopMouseUpPropagation}
                                />
                            </Animated>
                        </Draggable>
                    }
                </div>
        }
    </>;  
}